import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { HostListener } from "@angular/core";
import { ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { User } from '../../../../../Leste 3.0/models/User'
import { Training } from 'src/app/models/training.model';
import { Observable, Subscription } from 'rxjs';
import { AuthService } from '../services/auth-service/auth.service';
import { UserLanguageService } from '../services/user-language-service/user-language.service';
import { NavigationEnd, Router } from '@angular/router';
import { UserDashboardService } from '../user-dashboard.service';
import { filter, share } from 'rxjs/operators';
import { Unit } from 'src/app/models/unit.model';
import { LocalStorageService } from '../services/localStorage-service/local-storage.service';
import { TestQuestionScore } from 'src/app/models/testQuestionScore.model';
import { MatDialog } from '@angular/material/dialog';
import { UserBeforeTestMessageComponent } from '../user-training/user-before-test-message/user-before-test-message.component';
import { UserBeforePreTestComponent } from '../pre-test/user-before-pre-test/user-before-pre-test.component'
import { MainHeaderComponent } from 'src/app/shared/user-components/main-header/main-header.component';
import { UserDashboardComponent } from 'src/app/layouts/user-dashboard/user-dashboard.component';
import { Test } from 'src/app/models/test.model';
import { Meeting } from 'src/app/models/meeting.model';
import { environment } from '../../../environments/environment.prod';
import {UserXTrainings} from '../../models/userXTrainings.model';
import {formatDate} from '@angular/common';
import {SuccessfullCompletedTraining} from '../test/successfull-completed-training/successfull-completed-training';
import {UserExpirationComponent} from "./user-expiration/user-expiration.component";

@Component({
    selector: 'app-user-dashboard-content',
    templateUrl: './user-dashboard-content.component.html',
    styleUrls: ['./user-dashboard-content.component.scss'],
    host: { '(click)': 'onClick()' },
    standalone: false
})
export class UserDashboardContentComponent implements OnInit, AfterViewInit, OnDestroy {

  test$: Observable<Test>
  user: User
  userSub: Subscription;

  lang
  langSub: Subscription;

  labels;
  labelsSub: Subscription;

  userTrainings$: Observable<Training[]>;
  imageUrl: string
  imageUrlMobile: string
  isMenuOpen: boolean = false
  trainings: Training[]
  noPendingTrainings: boolean = false
  userTraining: UserXTrainings[]
  trainingsSub: Subscription;

  currentUnit$: Observable<Unit>

  toggle: boolean = true
  btnView: String = "Prikaži sve"
  btnInfo: String = "Info"
  btnNastavi: String = "Nastavi"
  lblCourses = "Dodeljeni treninzi"
  lblHeader = "Turn your ambition into a success story"
  numOfUnits
  routerSubscription: Subscription
  colorClass = ""
  backgroundColor
  buttonStyle = ""
  borderStyle
  buttonStyle1
  dialogOpened = false
  content = ""
  contentAll = ""
  meetings
  depId
  showTrainings: boolean = true
  matDialog: any
  @Output() toggleSideBarForMe: EventEmitter<any> = new EventEmitter()

  @ViewChild('finishedScroll', { read: ElementRef }) finishedScrollContainer: ElementRef<HTMLElement> | undefined;
  isFinishedStart: boolean = true;
  isFinishedEnd: boolean = true;
  private resizeHandler: any;
  private finishedScrollListener: any;

  constructor(public dialog: MatDialog, private authService: AuthService, private languageService: UserLanguageService, private router: Router, private userDashboarService: UserDashboardService, private localStorageService: LocalStorageService, private component: UserDashboardComponent) {

  }

  ngOnInit() {
    this.langSub = this.languageService.lang$.subscribe((lang) => {
      this.lang = lang;

      switch (lang) {
        case 'eng':
          this.imageUrl = environment.coverImagePath1 || "./assets/icons/Naslovna-fotka.png"
          this.imageUrlMobile = environment.coverImagePathMobile1 || "./assets/icons/Naslovna-fotka.png"
          break;
        case 'srb':
          this.imageUrl = environment.coverImagePath2 || "./assets/icons/Naslovna-fotka.png"
          this.imageUrlMobile = environment.coverImagePathMobile2 || "./assets/icons/Naslovna-fotka.png"
          break;
        default:
          this.imageUrl = environment.coverImagePath3 || "./assets/icons/Naslovna-fotka.png"
          this.imageUrlMobile = environment.coverImagePathMobile3 || "./assets/icons/Naslovna-fotka.png"
      }
    })

    this.localStorageService.setItem('test', null)
    this.localStorageService.removeItem('minutesLeft')
    this.localStorageService.removeItem('secondsLeft')
    this.localStorageService.removeItem('currentUnit')
    this.colorClass = ""


    this.userSub = this.authService.user$.subscribe((user: User) => {
      this.user = user;
      console.debug('UserDashboardContentComponent: user updated', user);
      if(user?.expirationDate && new Date(user?.expirationDate) < new Date() && (user.notStarted || user.started)){
        let dialogRef = this.dialog.open(UserExpirationComponent, {
          width: '400px',
          disableClose: true
        })
      }
     setTimeout(() => {
       this.depId = this.user?.departmentId
       //this.meetings =  this.getZoomMeetings(this.depId)
     }, 300);
    });

    this.labelsSub = this.languageService.labels$.subscribe((labels) => {
      this.labels = labels;
    })
    this.userTrainings$ = this.authService.getCurrentUsersTrainings().pipe(share());
    this.trainingsSub = this.authService.usersTrainings$.subscribe((trainings) => {
      if(trainings && trainings.length > 0) {
        this.noPendingTrainings = trainings[0].noPendingTrainings ?? false
        if(this.noPendingTrainings) {
          this.openFinishedTrainingDialog()
        }
      }
      this.trainings = trainings;

      // Update scroll buttons after trainings are loaded
      setTimeout(() => this.updateFinishedScrollButtons(), 100);
    })
    this.localStorageService.setItem('test', null)
    this.localStorageService.removeItem('survey')
    this.localStorageService.removeItem('pretest')
    this.localStorageService.setItem('currentQuestionIndex', 0)
    this.btnView = this.labels.lblShowAll

  }
  ngAfterViewInit() {
    // keep previous scroll-to-top behavior
    setTimeout(() => window.scroll(0, 0), 0);

    // Wait a tick for the content to render then update arrow states
    setTimeout(() => this.updateFinishedScrollButtons(), 50);

    // attach scroll listener to finished container
    if (this.finishedScrollContainer) {
      const el = this.finishedScrollContainer.nativeElement;
      this.finishedScrollListener = () => this.updateFinishedScrollButtons();
      el.addEventListener('scroll', this.finishedScrollListener);
    }

    // update on window resize as well
    this.resizeHandler = () => this.updateFinishedScrollButtons();
    window.addEventListener('resize', this.resizeHandler);
  }

  ngOnDestroy() {
    if (this.resizeHandler) { window.removeEventListener('resize', this.resizeHandler); }
    if (this.finishedScrollContainer && this.finishedScrollListener) {
      this.finishedScrollContainer.nativeElement.removeEventListener('scroll', this.finishedScrollListener);
    }
    // unsubscribe existing subscriptions to avoid leaks
    this.userSub?.unsubscribe();
    this.langSub?.unsubscribe();
    this.labelsSub?.unsubscribe();
    this.trainingsSub?.unsubscribe();
  }

  openFinishedTrainingDialog(): void {
    if (this.dialogOpened) {
      return;
    }
    this.dialogOpened = true;
    /*this.matDialog = this.dialog.open(SuccessfullCompletedTraining, {
      width: '350px',
    })*/
  }

  onActivate(event) {
    setTimeout(() => window.scroll(0, 0), 0);
  }

  toggleClass() {
    this.toggle = !this.toggle;
  }

  whatToShow() {
    this.showTrainings = !this.showTrainings
  }

  goToTrainingDetails(training: Training) {

    this.userDashboarService.setTraining(training)
    this.router.navigateByUrl('user/training-details');
  }
  goToTraining(training: Training) {
    if (training.status == 1) {
      this.userDashboarService.setTraining(training)
      this.router.navigateByUrl('user/welcome');
    } else {
      this.userDashboarService.setTraining(training)

      this.userDashboarService.setTraining(training)

      const tr = this.user.trainings.filter((t) => t.trainingId == training._id)[0]

      this.currentUnit$ = this.userDashboarService.getCurrentUnit(training._id).pipe(share());

      if (!tr.pretestFlag && training.pretestId != "") {
        this.test$ = this.userDashboarService.getTestForTraining(this.localStorageService.getItem('pretestId')).pipe(share())
        this.router.navigateByUrl('user/start-pretest');
      }
      else {
        this.router.navigateByUrl('user/training');
      }
      this.changeStatus(training, 2)
    }
  }

  changeStatus(training: Training, status: Number) {
    this.userDashboarService.changeTrainingStatus(training._id, status).subscribe((result) => {
      console.log(result)
    })
  }

  selectLang(lang) {
    this.languageService.setLanguage(lang);
  }

  toogleMenu() {
    this.isMenuOpen = !this.isMenuOpen
  }

  logout(): void {
    this.authService.logout();
    this.router.navigateByUrl('/');
  }

  openTestDialog(): void {
    const dialogRef = this.dialog.open(UserBeforePreTestComponent, {
      disableClose: true,
      width: '350px'
    });

  }

  setNumOfUnits(trainings: Training[]) {
    trainings.forEach((tr) => {
      tr.num_of_units = this.totalNumOfUnits(tr)
    })
  }

  totalNumOfUnits(tr: Training) {
    let allUnits = []
    tr.sections.forEach((s) => {
      s.units.forEach((u) => {
        allUnits.push(u)
      })
    })
    return allUnits.length
  }

  @HostListener("click") onClick() {
    this.component.sideBarOpened = false
  }

  /** Scroll finished trainings container left or right */
  scrollFinished(direction: 'left' | 'right') {
    const el = this.finishedScrollContainer?.nativeElement;
    if (!el) { return; }
    const scrollAmount = Math.max(200, Math.floor(el.clientWidth * 0.8));
    const target = direction === 'left' ? Math.max(0, el.scrollLeft - scrollAmount) : Math.min(el.scrollWidth - el.clientWidth, el.scrollLeft + scrollAmount);
    el.scrollTo({ left: target, behavior: 'smooth' });
    // schedule a check after smooth scroll
    setTimeout(() => this.updateFinishedScrollButtons(), 350);
  }

  updateFinishedScrollButtons() {
    const el = this.finishedScrollContainer?.nativeElement;
    if (!el) { this.isFinishedStart = true; this.isFinishedEnd = true; return; }
    const eps = 2;
    this.isFinishedStart = el.scrollLeft <= eps;
    this.isFinishedEnd = (el.scrollLeft + el.clientWidth) >= (el.scrollWidth - eps);
  }

  protected readonly formatDate = formatDate;
}
